'use strict';
exports.init = function () {

    var opts = $('.core-storelocator').data('options');

    if (window.location.protocol === 'http:') {
        toHttps();
    } else if (opts.storeLocatorName === 'storeLocatorBaidu') {

        var storelocatorBaidu = require('app_custom_storelocator/storeLocator/storelocatorBaidu.js');
        $(document).ready(function() {
            storelocatorBaidu.init();
        });
    } else {
        var storelocatorGoogle = require('./storelocatorGoogle');
        $(document).ready(function() {
            storelocatorGoogle.init();
        });
    }
}

function toHttps() {
    window.location.protocol = 'https:';
}
